/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import {GenericObject} from '@ion/core/src/types/entities';
import {TombstoneLoader} from '@ion/dls/src/components/loading/TombstoneLoader';
import {DLSTheme} from '@ion/dls/src/types/types';
import {ChartsAccordion} from './ChartsAccordion';
import {ChartsTooltip} from './ChartsTooltip';

export interface IonTagSensorGraphsProps {
  data: GenericObject;
  loading: boolean;
}

const useStyles = makeStyles((theme: DLSTheme) => ({
  loader : {
    height : 152
  }
}));

const IonTagSensorGraphs = ({data, loading}: IonTagSensorGraphsProps) => {
  const classes = useStyles();

  if (!loading) {
    return (
      <>
        {data?.map((sensorData) => {
          const {data, title, threshold, sensorType, noDataLabel} = sensorData;
          return (
            <ChartsAccordion key={sensorType}
              data={{
                id        : sensorType,
                data      : data,
                threshold : threshold
              }}
              title={title}
              loading={data?.loading}
              customToolTip={ChartsTooltip}
              noDataLabel={noDataLabel}
              includeLegends={false}
              containTooltip />
          );
        })}
      </>
    );
  }
  return (
    <div className={classes.loader}>
      <TombstoneLoader />
    </div>
  );
};

export default IonTagSensorGraphs;
